import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import TeamHeader from './TeamHeader';
import TeamHero from './TeamHero';
import TeamTabs from './TeamTabs';
import TeamStats from './TeamStats';
import TeamCharts from './TeamCharts';
import TeamBoxscore from './TeamBoxscore';
import TeamLineups from './TeamLineups';
import TeamComboDuos from './TeamComboDuos';
import TeamNeuro from './TeamNeuro';
import { TeamOnOff } from './TeamOnOff';
const TeamDetail = () => {
  const {
    teamId
  } = useParams();
  const [activeTab, setActiveTab] = useState('overview');
  return <div className="w-full max-w-7xl mx-auto pb-12 px-4" data-id="element-297" data-mp="1yys25491yzwz">
      <TeamHeader data-id="element-298" data-mp="1yx78rhyh5n0p" />
      <TeamHero data-id="element-299" data-mp="1z0v48mnhcji2" />
      <TeamTabs activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-300" data-mp="1u07cfyrffyms" />
      <div className="mt-6" data-id="element-301" data-mp="1u21oenkq0geq">
        {activeTab === 'overview' && <TeamStats activeTab={activeTab} data-id="element-302" data-mp="nkwmzvi5er5r" />}
        {activeTab === 'neuro' && <TeamNeuro data-id="element-303" data-mp="il1x9va407ma" />}
        {activeTab === 'lineups' && <TeamLineups data-id="element-304" data-mp="ij7byfuxedho" />}
        {activeTab === 'onOff' && <TeamOnOff data-id="element-305" data-mp="14xpxz8xgu5b0" />}
        {activeTab === 'boxscore' && <TeamBoxscore data-id="element-306" data-mp="14xya2ylrl6l5" />}
        {activeTab === 'charts' && <TeamCharts data-id="element-307" data-mp="18zjv578gcr6f" />}
        {activeTab === 'comboDuos' && <TeamComboDuos data-id="element-308" data-mp="18y8q7439tddq" />}
        {activeTab === 'roster' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-309" data-mp="uzscuuawkomm">
            Roster Content
          </div>}
        {activeTab === 'calendar' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-310" data-mp="zwsfev8jn98z">
            Calendar Content
          </div>}
        {activeTab === 'highs' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-311" data-mp="l7mhdalfzp2o">Highs Content</div>}
        {activeTab === 'news' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-312" data-mp="c8rd441ykp20">News Content</div>}
        {activeTab === 'staff' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-313" data-mp="h7vmauovumsc">Staff Content</div>}
        {activeTab === 'club' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-314" data-mp="2av3xhsl046j">Club Content</div>}
      </div>
    </div>;
};
export default TeamDetail;